import React, { Component } from "react";
import moment from "moment-hijri";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Spin } from "antd";

class ClientInfo extends Component {

    state = {
        showAdd: false,
        loading  : false,
    }

    componentDidMount() {
      this.setState({loading : true})
    }

    handelShowInfo = () => {
        this.setState({showAdd: false})
    }

  render() {
    const { userData, loading } = this.props;

    return (
      <div className="client-info-wrapper">

        <header className="client-header">
          <h2 className="header-title">بيانات العميل</h2>
        </header>

        <Spin spinning={loading}>

        <div className="info-grid">
          <div className="info-grid-cell">
            <p className="info-cell-p">رقم هوية العميل</p>
            <h6 className="info-cell-val">{userData?.NationalIdentityNumber}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">اسم العميل</p>
            <h6 className="info-cell-val">{userData?.AspNetUsers?.FullName}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">البريد الالكتروني</p>
            <h6 className="info-cell-val">{userData?.AspNetUsers?.Email}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">رقم الجوال</p>
            <h6 className="info-cell-val phone-style">{userData?.AspNetUsers?.PhoneKey + userData?.AspNetUsers?.PhoneNumber}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">تاريخ الميلاد</p>
            <h6 className="info-cell-val">{moment(userData?.BirthDate).format('DD/MM/YYYY')}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">المنطقة</p>
            <h6 className="info-cell-val">{userData?.City.NameLT}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">جهة العمل</p>
            <h6 className="info-cell-val">{userData?.Employer?.NameLT}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p"> اسم جهة العمل</p>
            <h6 className="info-cell-val">{userData?.EmployerName} </h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">الراتب الاساسي</p>
            <h6 className="info-cell-val">{userData?.Salary}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">بدل السكن</p>
            <h6 className="info-cell-val">{userData?.HousingAllowance}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">بدل النقل</p>
            <h6 className="info-cell-val">{userData?.TransportationAllowance}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">البنك</p>
            <h6 className="info-cell-val">{userData?.Bank?.NameLT}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">نوع العميل</p>
            <h6 className="info-cell-val">{userData?.Gender?.NameLT}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">مدعوم</p>
            <h6 className="info-cell-val">{userData?.IsSupported?"نعم":"لا"}</h6>
          </div>
        </div>

        </Spin>
      </div>
    );
  }
}

const ClientInfoWithRouter = withRouter(ClientInfo);
const mapStateToProps = (state) => ({
  currentUser : state.user.currentUser,
  currentLang : state.user.currentLang,
  userRequest : state.user.userRequest,
}) 
export default connect(mapStateToProps)(ClientInfoWithRouter); 